import { createFileRoute } from "@tanstack/react-router";
import { WorkingBoard } from "@/components/working/WorkingBoard";

export const Route = createFileRoute("/(protected)/_layout/prep")({
  component: PrepPage,
});

/** What the kitchen queued for itself — no ticket attached. */
function PrepPage() {
  return <WorkingBoard source="prep" from="/prep" />;
}
